import { GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid";
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from "@mui/x-data-grid-premium";
import { GridInitialStatePremium } from "@mui/x-data-grid-premium/models/gridStatePremium";

/** Must match `TasksTable` column `field` order (see `columns` useMemo). */
const columnNames = [
    GRID_DETAIL_PANEL_TOGGLE_COL_DEF.field,
    GRID_CHECKBOX_SELECTION_COL_DEF.field,
    "index",
    "status",
    "accommodation",
    "pickUp",
    "passengerCount",
    "driverUserId",
    "actions",
];

export const defaultTasksTableGridOptions: GridInitialStatePremium = {
    pinnedColumns: {
        left: [GRID_DETAIL_PANEL_TOGGLE_COL_DEF.field, GRID_CHECKBOX_SELECTION_COL_DEF.field, "index"],
        right: ["actions"],
    },
    columns: {
        orderedFields: columnNames,
        columnVisibilityModel: columnNames.reduce(
            (acc, field) => {
                acc[field] = true;
                return acc;
            },
            {} as Record<string, boolean>
        ),
    },
    sorting: {
        sortModel: [{ field: "pickUp", sort: "asc" }],
    },
};

export const tasksTableToolbarNewColumnNames: string[] = [];
